<template>
  <v-avatar :size="size" class="avatar">
    <v-img :src="avatarUrl" />
  </v-avatar>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    first_name: {
      type: String,
      default: "",
    },
    last_name: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    avatarUrl() {
      if (this.url && this.url != "null" && this.url != null) {
        return `${process.env.VUE_APP_S3_BUCKET_URL}/${this.url}`;
      } else {
        return (
          "https://eu.ui-avatars.com/api/?name=" +
          this.first_name +
          "+" +
          this.last_name +
          "&background=" +
          this.HSLToHex(
            this.stringToHslColor(
              this.first_name + " " + this.last_name,
              40,
              65
            )
          ) +
          "&color=fff&size=" +
          this.size
        );
      }
    },
  },
  methods: {
    stringToHslColor(str, s, l) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return [h, s, l];
    },
    HSLToHex(hsl) {
      let h = hsl[0];
      let s = hsl[1];
      let l = hsl[2];

      s /= 100;
      l /= 100;

      let c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs(((h / 60) % 2) - 1)),
        m = l - c / 2,
        r = 0,
        g = 0,
        b = 0;

      if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
      } else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
      } else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
      } else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
      } else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
      } else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
      }
      // Having obtained RGB, convert channels to hex
      r = Math.round((r + m) * 255).toString(16);
      g = Math.round((g + m) * 255).toString(16);
      b = Math.round((b + m) * 255).toString(16);

      // Prepend 0s, if necessary
      if (r.length == 1) r = "0" + r;
      if (g.length == 1) g = "0" + g;
      if (b.length == 1) b = "0" + b;

      return r + g + b;
    },
  },
};
</script>
